export const WIN_DRAW_WIN = {
    name: 'WIN_DRAW_WIN',
    code: '9'
};
export const CORRECT_SCORE = {
    name: 'CORRECT_SCORE',
    code: '10'
};
export const TOTAL_GOALS = {
    name: 'TOTAL_GOALS',
    code: '11'
};
export const DOUBLE_CHANCE = {
    name: 'DOUBLE_CHANCE',
    code: '12'
};
// export const DOUBLE_CHANCE_1 = '13' export const DOUBLE_CHANCE_2 = '14'
export const UNDER_OVER_25 = {
    name: 'UNDER_OVER_25',
    code: '15'
};
export const UNDER_OVER_15 = {
    name: 'UNDER_OVER_15',
    code: '16'
};
export const ASIAN_HANDICAP = {
    name: 'ASIAN_HANDICAP',
    code: '17'
};
export const UNDER_OVER = {
    name: 'UNDER_OVER_MATCHDAY',
    code: 'UNDER_OVER_MATCHDAY'
};
export const UNDER_OVER_05 = {
    name: 'UNDER_OVER_05',
    code: '23'
};
export const UNDER_OVER_35 = {
    name: 'UNDER_OVER_35',
    code: '24'
};
export const BOTH_TEAMS_SCORE = {
    name: 'BOTH_TEAMS_SCORE',
    code: '25'
};
export const HOME_TEAM_GOALS = {
    name: 'HOME_TEAM_GOALS',
    code: '26'
};
export const AWAY_TEAM_GOALS = {
    name: 'AWAY_TEAM_GOALS',
    code: '27'
};
export const MATCH_BETTING_BOTH_TEAMS_SCORE = {
    name: 'MATCH_BETTING_BOTH_TEAMS_SCORE',
    code: '28'
};
export const WINNING_MARGIN = {
    name: 'WINNING_MARGIN',
    code: '29'
};
export const CORRECT_SCORE_GROUP = {
    name: 'CORRECT_SCORE_GROUP',
    code: '30'
};
export const HOME_TEAM_TO_SCORE = {
    name: 'HOME_TEAM_TO_SCORE',
    code: '35'
};
export const AWAY_TEAM_TO_SCORE = {
    name: 'AWAY_TEAM_TO_SCORE',
    code: '36'
};
export const FIRST_TEAM_TO_SCORE = {
    name: 'FIRST_TEAM_TO_SCORE',
    code: '37'
};
export const LAST_TEAM_TO_SCORE = {
    name: 'LAST_TEAM_TO_SCORE',
    code: '38'
};
export const HALF_TIME_FULL_TIME = {
    name: 'HALF_TIME_FULL_TIME',
    code: '39'
};
export const TEAM_SCORECAST = {
    name: 'TEAM_SCORECAST',
    code: '40'
};
export const HALF_TIME_CORRECT_SCORE = {
    name: 'HALF_TIME_CORRECT_SCORE',
    code: '41'
};
export const HALF_TIME_RESULT = {
    name: 'HALF_TIME_RESULT',
    code: '42'
};

export const HANDICAP = {
    name: 'HANDICAP',
    code: 'HANDICAP'
};
export const HANDICAP_FIRST = {
    name: 'HANDICAP_FIRST',
    code: '31'
};
export const HANDICAP_SECOND = {
    name: 'HANDICAP_SECOND',
    code: '33'
};
export const ALL_MATCHDAY_MARKETS = [
    WIN_DRAW_WIN,
    BOTH_TEAMS_SCORE,
    UNDER_OVER,
    UNDER_OVER_05,
    UNDER_OVER_15,
    UNDER_OVER_25,
    UNDER_OVER_35,
    TOTAL_GOALS,
    HANDICAP,
    HANDICAP_FIRST,
    HANDICAP_SECOND,
    CORRECT_SCORE,
    DOUBLE_CHANCE,
];


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/matchday/constants/marketTypes.js